/**
 * CalendarIcon — issue #438 visual system. Single icon in the brand
 * palette (currentColor stroke, 2px line, rounded caps). Tree-shakable
 * via direct import path:
 *
 *   import { CalendarIcon } from './icons/CalendarIcon';
 *
 * Accepts `size` (default 20) and `className`. Omit `aria-label` to
 * mark the icon as decorative (`aria-hidden="true"` by default); supply
 * `aria-label` to render as a labelled image with `role="img"`.
 */
import type { ReactElement } from 'react';
import type { IconProps } from './iconTypes';
import { SHARED_ICON_ATTRS } from './iconTypes';

export function CalendarIcon({ size = 20, className, ...rest }: IconProps): ReactElement {
  const aria = rest['aria-label']
    ? { role: 'img' as const, 'aria-label': rest['aria-label'] }
    : { 'aria-hidden': true };
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      {...SHARED_ICON_ATTRS}
      {...aria}
      {...className ? { className } : undefined}
      {...rest}
    >
      <rect width="18" height="18" x="3" y="4" rx="2" />
      <path d="M16 2v4" />
      <path d="M8 2v4" />
      <path d="M3 10h18" />
    </svg>
  );
}
